import React from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import cx from 'clsx';
import PropTypes from 'prop-types';
import styles from './ModuleMultiColumnCards.module.scss';
import ModuleCard, { ModuleCardPropTypes } from '../ModuleCard';
import useTranslation from 'next-translate/useTranslation';

export const ModuleMultiColumnCardsPropTypes = {
  _id: PropTypes.string.isRequired,
  _contentTypeId: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  cards: PropTypes.arrayOf(PropTypes.shape(ModuleCardPropTypes)).isRequired
};

function ModuleMultiColumnCards({ _id /* , _contentTypeId */, title = null, subtitle = null, cards }) {
  const { lang } = useTranslation();

  return (
    <div data-testid="ModuleMultiColumnCards" className={styles.moduleContainerWrap}>
      {title || subtitle ? (
        <div className={styles.sectionHeaderWrap} data-testid="ModuleMultiColumnCards-header">
          {title ? (
            <div className={styles.sectionTitleWrap} {...sidekick(_id, 'title')}>
              <h3 className={styles.sectionTitle} data-testid="ModuleMultiColumnCards-title">
                {typeof title === "object" ? title[lang] : title}
              </h3>
            </div>
          ) : null}

          {subtitle ? (
            <div className={styles.subtitleWrap} {...sidekick(_id, 'subtitle')}>
              <h5 className={styles.subtitle} data-testid="ModuleMultiColumnCards-subtitle">
                {subtitle}
              </h5>
            </div>
          ) : null}
        </div>
      ) : null}

      {cards && cards.length ? (
        <div
          data-testid="ModuleMultiColumnCards-CardsWrap"
          className={styles.moduleContainerRow}
          {...sidekick(_id, 'cards')}>
          {cards.map((card, key) => (
            <div key={key}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <ModuleCard {...card} className={styles.card} />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
ModuleMultiColumnCards.propTypes = ModuleMultiColumnCardsPropTypes;

export default ModuleMultiColumnCards;